import { BaseModel } from '../../../models/base-model'
import { Question } from '../'

export class Container extends BaseModel {
  public name: string
  public description: string
  public status: string
  public containers: Container[] = []
  public questions: Question[] = []

  public addQuestion(question: Question) {
    const isQuestionInContainer = this.questions.some((_question) => question.id === _question.id)
    if (! isQuestionInContainer) {
      this.questions.push(question)
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/models/container/container.ts